import {Button} from 'devextreme-react/button'
import DataGrid, {
    Column,
    Editing, FilterRow, HeaderFilter,
    Pager,
    Paging,
    Scrolling,
    Sorting,
    Toolbar,
} from 'devextreme-react/data-grid'
import LoadPanel from 'devextreme-react/load-panel'
import React, {useEffect, useState, useRef, useCallback} from "react"
import {useHistory} from "react-router-dom"
import {getPoints} from "../../services/point.service"
import {sendIntervalAkt} from "../../api/point"
import {getBlankExcel, getData, getObjects, saveData, uploadExcel} from "../../api/range-volumes"
import notify from "devextreme/ui/notify"
import PopupIntegral from "../../components/reads-popup-integral/reads-popup-integral"
import {getCurrentPeriod} from "../../api/dogovor"
import {useAuth} from "../../contexts/auth"
import PopupInterval from "../../components/reads-popup-interval/reads-popup-interval"
import {verifyAccess} from "../../utils/admin.utils"
import AccessDenied from "../../components/access-denied/access-denied"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faShareFromSquare, faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";
import PopupPointsTreeHook from "../../components/points-tree/popup-point-tree-hook"
import {Buffer} from 'buffer';
import NumberEditor from "../../components/number-editor/number-editor";
import TreeHook from "../../components/points-tree/tree-hook";
import {useScreenSize} from "../../utils/media-query";
import {Item} from "devextreme-react/toolbar";
import {PopupTitleWithIcon} from "../../components/popup-title-with-icon/popup-title-with-icon";
import ScrollView from "devextreme-react/scroll-view";
import {Popup} from "devextreme-react/popup";
import './range-volumes.scss'
import ZagolovokFromMenu from "../../components/zagolovok/zagolovok";
import ErrorPopup from "../../components/error-popup/error-popup";


const RangeVolumesPage = () => {
    let { isLarge } = useScreenSize();
    const history = useHistory();
    const [visibleGrid, setVisibleGrid] = useState(false)
    const [loading, setLoading] = useState(false)
    const [dataSource, setDataSource] = useState({ ym: null, rows: [] })
    const [selectedPoints, setSelectedPoints] = useState([])
    const [loadExcelVisible, setLoadExcelVisible] = useState(false)
    const [loadIntervalVisible, setLoadIntervalVisible] = useState(false)
    const [uploadMultiple, setUploadMultiple] = useState(false)
    const { selectedDog, updateCountNotReads } = useAuth()
    const [currentPeriod, setCurrentPeriod] = useState({})
    const [leavePopupVisible, setLeavePopupVisible] = useState(false)
    const unblockRef = useRef(null)
    const pendingActionRef = useRef(null)
    const allowLeaveRef = useRef(false)
    const selectedPointsRef = useRef([])
    const treeRef = useRef(null)
    const [points, setPoints] = useState(null)
    const [visiblePage, setVisiblePage] = useState(true)
    const [loadingVisibleTreeHook, setloadingVisibleTreeHook] = useState(false)
    const dataGridRef = useRef(null);
    const [popupVisible, setPopupVisible] = useState(false);

    const samePointSelection = (a, b) => {
        if (a.length !== b.length) return false
        const bSet = new Set(b.map(String))
        return a.every((p) => bSet.has(String(p)))
    }

    const applyTreeSelection = useCallback((mas) => {
        const nextPoints = getPoints(mas)
        if (samePointSelection(selectedPointsRef.current, nextPoints)) return

        selectedPointsRef.current = nextPoints
        setSelectedPoints(nextPoints)
        setVisibleGrid(nextPoints.length > 0)
        if (nextPoints.length === 0) setDataSource({ ym: null, rows: [] })
    }, [])

    const onTreeSelect = applyTreeSelection

    useEffect(() => {
        const pageRoles = [2]
        if (!verifyAccess(pageRoles, selectedDog)) {
            setVisiblePage(false)
            return
        }
        (async function () {
            setVisiblePage(true)
            setLoading(true)
            setPoints(null)
            setDataSource({ ym: null, rows: [] })
            selectedPointsRef.current = []
            setSelectedPoints([])
            setloadingVisibleTreeHook(true)
            //получаем точки по договору
            const res = await getObjects(selectedDog.kodDog)
            if (res.isOk) {
                setPoints(res.data)
            } else {
                notify(res.message, 'error', 5000)
            }

            //получаем период по договору
            const periodRes = await getCurrentPeriod(selectedDog.kodDog)
            if (periodRes.isOk) {
                setCurrentPeriod(periodRes.data)
            } else {
                notify(periodRes.message,'error',5000)
            }
            setLoading(false)
            setloadingVisibleTreeHook(false)
        })()
    }, [selectedDog])

    const onRefreshClick = async () => {
        setLoading(true)
        if (selectedPoints.length > 0) {
            const res = await getData(selectedDog.kodDog, selectedPoints.map(Number))
            if (res.isOk) {
                setDataSource({
                    ym: res.data?.ym ?? currentPeriod.ym,
                    rows: res.data?.rows ?? []
                })
            } else {
                notify(res.message, 'error', 5000)
                setDataSource({ ym: null, rows: [] })
            }
        } else {
            setDataSource({ ym: null, rows: [] })
        }
        setLoading(false)
    }

    /*const onIsue = async () => {
        setLoading(true)
        if (selectedPoints.length > 0) {
            let resToken
            if (+selectedDog.parameter_uk !== 1) {
                resToken = await getToken(dataSource[0]?.num_pu)
            } else {
                resToken = await getTokenUk(fias[0])
            }//'885b2c35-8547-4946-8a7d-20c47df8a0c9'
            if (resToken.isOk) {
                let json = resToken.data
                if (json.hasOwnProperty('token')){
                    window.open(json.url + json.token, '_blank');
                } else {
                    notify('Объект не содержит token', 'error', 3000)
                }
            } else {
                notify(resToken.message, 'error', 3000)
            }
        } else notify('Не выбран объект', 'error', 3000)
        setLoading(false)
    }*/

    const loadExcel = () => {
        setUploadMultiple(false)
        setLoadExcelVisible(true)

    }

    const onHidingIntegralPopup = () => {
        setLoadExcelVisible(false)
    }

    const onHidingIntervalPopup = () => {
        setLoadIntervalVisible(false)
    }

    const loadRangeVolumesTemplate = async () => {
        if (!selectedPoints.length) {
            notify('Не выбраны объекты', 'error', 5000)
            return
        }
        if (!currentPeriod.ym) {
            notify('Не определен отчетный период', 'error', 5000)
            return
        }

        setLoading(true)
        try {
            const res = await getBlankExcel(
                selectedDog.kodDog,
                currentPeriod.ym,
                selectedPoints.map(Number)
            )
            if (res.isOk){
                const fileDownload = require('js-file-download')
                fileDownload(Buffer.from(res.data.data), res.data.filename)
            } else notify(res.message,'error',5000)
        } catch (error) {
            notify(error.message || 'Не удалось скачать шаблон', 'error', 5000)
        } finally {
            setLoading(false)
        }
    }

    const onSendIntegralFile = async (files) => {
        setLoading(true);

        const fd = new FormData()
        for (let i=0; i<files.length; i++) {
            fd.append('files',files[i])
        }
        fd.append('dogovor', selectedDog.kodDog)
        fd.append('period', currentPeriod.ym)
        //console.log(fd)

        const result = await uploadExcel(fd)
        if (result.isOk) {
            setLoadExcelVisible(false)
            notify(result.message, 'success', 5000)
            await onRefreshClick()
        } else {
            notify(result.message, 'error', 10000);
        }

        setLoading(false)
    }

    const onSendIntervalFile = async (files) => {
        setLoading(true);

        const fd = new FormData()
        for (let i=0; i<files.length; i++) {
            fd.append('files',files[i])
        }
        fd.append('dogovor', selectedDog.kodDog)
        fd.append('period', currentPeriod.period)
        //console.log(fd)

        const result = await sendIntervalAkt(fd)
        if (result.isOk) {
            setLoadIntervalVisible(false)
            notify(result.message, 'success', 5000)
            updateCountNotReads(selectedDog)
        } else {
            notify(result.message, 'error', 10000);
        }

        setLoading(false)
    }

    const pageSizes = [10, 25, 50, 100]

    function isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    // Итог гр.5 = сумма объёмов гр.7+8+10+12+14 (ОДН — col8), счётчики ЛС (col6, 9, 11, 13) в него не входят.
    // В подписи официальной формы «5 =7+9+10+12+14» — опечатка.
    const VOL_TOTAL_FIELDS = [
        'col7_vol_d1',
        'col8_vol_odn_d1',
        'col10_vol_md_d1',
        'col12_vol_d2',
        'col14_vol_d3'
    ]

    const toNum = (value) => {
        if (value == null || value === '') return 0
        const n = parseFloat(String(value).toString().replace(',', '.'))
        return Number.isFinite(n) ? n : 0
    }

    const calcCol5VolTotal = (rowData) => {
        if (!rowData) return 0
        return VOL_TOTAL_FIELDS.reduce((sum, field) => sum + toNum(rowData[field]), 0)
    }

    const setVolCellValue = (field) => (newData, value, currentRowData) => {
        newData[field] = value
        newData.col5_vol_total = calcCol5VolTotal({ ...currentRowData, ...newData })
    }

    const editActionsRef = useRef(null)
    const hasChangesRef = useRef(false)

    const hasUnsavedChanges = useCallback(() => {
        const changes = dataGridRef.current?.instance?.option("editing.changes") || []
        return hasChangesRef.current || changes.length > 0
    }, [])

    const setEditButtonsEnabled = (enabled) => {
        hasChangesRef.current = enabled
        editActionsRef.current?.classList.toggle('is-disabled', !enabled)
    }

    const editActionsRefCallback = (el) => {
        editActionsRef.current = el
        // Toolbar грида может пересоздать item при вводе — восстанавливаем класс из ref
        if (el) {
            el.classList.toggle('is-disabled', !hasChangesRef.current)
        }
    }

    // Активируем Save/Отмена сразу при вводе, не дожидаясь blur ячейки
    const bindEditorSetValue = (setValue) => (value) => {
        setValue(value)
        setEditButtonsEnabled(true)
    }

    const editCellRender = (params) => (
        <NumberEditor value={params.value} setValue={bindEditorSetValue(params.setValue)}/>
    )

    const discardUnsavedChanges = () => {
        dataGridRef.current?.instance?.cancelEditData?.()
        setEditButtonsEnabled(false)
    }

    const shouldAllowTreeSelectionChange = useCallback((selectedRows) => {
        const nextPoints = getPoints(selectedRows || [])
        if (samePointSelection(selectedPointsRef.current, nextPoints)) return true
        if (allowLeaveRef.current || !hasUnsavedChanges()) return true

        pendingActionRef.current = {
            kind: 'tree',
            ids: (selectedRows || []).map((row) => row.id),
            selected: selectedRows || []
        }
        setLeavePopupVisible(true)
        return false
    }, [hasUnsavedChanges])

    useEffect(() => {
        unblockRef.current = history.block((location, action) => {
            if (allowLeaveRef.current || !hasUnsavedChanges()) {
                return undefined
            }
            pendingActionRef.current = { kind: 'nav', location, action }
            setLeavePopupVisible(true)
            return false
        })
        return () => {
            if (unblockRef.current) {
                unblockRef.current()
                unblockRef.current = null
            }
        }
    }, [history, hasUnsavedChanges])

    useEffect(() => {
        const onBeforeUnload = (e) => {
            if (!hasUnsavedChanges()) return
            e.preventDefault()
            e.returnValue = ''
            return ''
        }
        window.addEventListener('beforeunload', onBeforeUnload)
        return () => window.removeEventListener('beforeunload', onBeforeUnload)
    }, [hasUnsavedChanges])

    const onLeaveCancel = () => {
        setLeavePopupVisible(false)
        pendingActionRef.current = null
    }

    const onLeaveContinue = () => {
        const pending = pendingActionRef.current
        pendingActionRef.current = null
        discardUnsavedChanges()
        setLeavePopupVisible(false)

        if (pending?.kind === 'tree') {
            allowLeaveRef.current = true
            window.setTimeout(() => {
                treeRef.current?.instance?.selectRows(pending.ids || [], false)
                applyTreeSelection(pending.selected || [])
                allowLeaveRef.current = false
            }, 0)
            return
        }

        if (!pending?.location) return

        allowLeaveRef.current = true
        if (unblockRef.current) {
            unblockRef.current()
            unblockRef.current = null
        }

        const { location, action } = pending
        const path = `${location.pathname}${location.search || ''}${location.hash || ''}`

        window.setTimeout(() => {
            if (action === 'REPLACE') {
                history.replace(path)
            } else if (action === 'POP') {
                history.goBack()
            } else {
                history.push(path)
            }
        }, 0)
    }

    // Логика отмены изменений
    const handleCancelClick = () => {
        if (dataGridRef.current) {
            dataGridRef.current.instance.cancelEditData()
            setEditButtonsEnabled(false)
        }
    };

    const saveTest = async () => {
        const changes = dataGridRef.current?.instance.option("editing.changes") || []
        if (changes.length === 0) {
            notify('Для передачи объёмов необходимо изменить хотя бы одно редактируемое значение!','error',10000)
            return
        }

        const editableFields = [
            'col6_ls_d1',
            'col7_vol_d1',
            'col8_vol_odn_d1',
            'col9_ls_md_d1',
            'col10_vol_md_d1',
            'col11_ls_d2',
            'col12_vol_d2',
            'col13_ls_d3',
            'col14_vol_d3'
        ]

        const rows = []
        for (const change of changes) {
            const key = change.key
            const sourceRow = (typeof key === 'object' && key != null)
                ? key
                : (dataSource.rows || []).find((r) => r.id === key || r.kod_numobj === key)

            if (!sourceRow) {
                notify('Не удалось сопоставить изменённую строку','error',5000)
                return
            }
            if (isRowAccepted(sourceRow)) {
                notify('Объект принят к расчету — редактирование запрещено','error',5000)
                return
            }

            const merged = { ...sourceRow, ...(change.data || {}) }

            const isEmpty = (value) => value == null || value === ''
            if (editableFields.some((field) => isEmpty(merged[field]))) {
                notify('Все поля строки должны быть заполнены', 'error', 5000)
                return
            }

            for (const field of editableFields) {
                const value = merged[field]
                if (!isNumeric(value)) {
                    notify('Значения могут содержать только цифры и знак разделителя "."!','error',5000)
                    return
                }
            }

            rows.push({
                kod_numobj: merged.kod_numobj,
                col5_vol_total: calcCol5VolTotal(merged),
                col6_ls_d1: merged.col6_ls_d1,
                col7_vol_d1: merged.col7_vol_d1,
                col8_vol_odn_d1: merged.col8_vol_odn_d1,
                col9_ls_md_d1: merged.col9_ls_md_d1,
                col10_vol_md_d1: merged.col10_vol_md_d1,
                col11_ls_d2: merged.col11_ls_d2,
                col12_vol_d2: merged.col12_vol_d2,
                col13_ls_d3: merged.col13_ls_d3,
                col14_vol_d3: merged.col14_vol_d3
            })
        }

        setLoading(true)
        const resData = await saveData(selectedDog.kodDog, selectedDog.ndog, rows)
        if (resData.isOk) {
            dataGridRef.current.instance.saveEditData()
            const now = new Date().toISOString()
            const savedKodNumobjs = new Set(rows.map((r) => r.kod_numobj))
            setDataSource((prev) => ({
                ...prev,
                rows: (prev.rows || []).map((row) =>
                    savedKodNumobjs.has(row.kod_numobj)
                        ? { ...row, t_sent: now }
                        : row
                )
            }))
            setEditButtonsEnabled(false)
            notify(resData.message || 'Объёмы по диапазонам переданы', 'success', 5000)
        } else {
            notify(resData.message, 'error', 5000)
        }
        setLoading(false)
    }

    const isRowAccepted = (row) => row?.accepted === true

    const acceptedCellRender = (data) => (
        <div>{data.data?.accepted === true ? 'принято' : ''}</div>
    )

    const editableColRender = (data) => {
        const field = data.column?.dataField
        const value = data.data?.[field]
        if (isRowAccepted(data.data)) {
            return <div>{value}</div>
        }
        return (
            <div style={{color: 'blue', cursor: 'pointer'}}>
                {value} &#9998;
            </div>
        )
    }

    const onEditingStart = (e) => {
        if (isRowAccepted(e.data)) {
            e.cancel = true
        }
    }

    const onCellPrepared = async (e) => {
        if (e.rowType === 'data' && e.column.name === 'readlast') {
            const counter = e.data.readlast
            const lastCounter = e.data.last_counter
            if (parseFloat(lastCounter) && (counter - parseFloat(lastCounter) < 0)) {
                e.cellElement?.classList.add('ie-error')
            }
        }
    }

    const hidePop = () => {
        setPopupVisible(false)
    }

    return (
        <>{visiblePage ?
            <div className={'content-block dx-card responsive-paddings big-input pokazania-edit'}>
                <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faShareFromSquare} />
                <h3><strong><ZagolovokFromMenu/></strong></h3>
                <div className={''}>
                    <LoadPanel visible={loading} />
                    <div className="row mt20">
                        {!isLarge ?
                            <div className="col-md-12">
                                <PopupPointsTreeHook
                                    points={points}
                                    onSelect={onTreeSelect}
                                    typePoints={'all'}
                                    selectionMode="multiple"
                                    onShow={onRefreshClick}
                                    showDisabled={selectedPoints.length === 0 || currentPeriod === {}}
                                    treeRef={treeRef}
                                    shouldAllowSelectionChange={shouldAllowTreeSelectionChange}
                                />
                            </div>
                            :
                            <div className="col-lg-3" id='tree-hook'>
                                <LoadPanel position={{ of: '#tree-hook' }} visible={loadingVisibleTreeHook}/>
                                <TreeHook
                                    points={points}
                                    onSelect={onTreeSelect}
                                    typePoints={'all'}
                                    selectionMode="multiple"
                                    treeRef={treeRef}
                                    shouldAllowSelectionChange={shouldAllowTreeSelectionChange}
                                />
                            </div>
                        }
                        <div id='form-container' className={(!isLarge ? "col-md-12" : "col-9") + " mt20lgx tree-hook-left"}>
                            {
                                visibleGrid ?
                                    <>
                                    <div className="alert alert-warning" role="alert">
                                        <i className="dx-icon-attention me-2"></i>
                                        * Объемы по диапазонам могут передавать ИКУ, получающие объемы в целом по МКД.<br/>
                                        ** Если Вы не нашли в перечне нужного дома для передачи объемов, Вам необходимо связаться с персональным менеджером по расчетам.<br/>
                                        *** Если объект принят к расчету, передавать информацию повторно нельзя. Для передачи информации по принятому объекту Вам необходимо связаться с персональным менеджером по расчетам.<br/>
                                        **** При наличии отрицательных объемов по диапазонам Вам необходимо официально обратиться к персональному менеджеру для проведения перерасчета ранее начисленных объемов и стоимости.<br/>
                                    </div>
                                    <DataGrid
                                        id="reads-grid"
                                        ref={dataGridRef}
                                        dataSource={dataSource.rows}
                                        showBorders={true}
                                        keyExpr="kod_numobj"
                                        //focusedRowEnabled={true}
                                        defaultFocusedRowIndex={0}
                                        columnHidingEnabled={false}
                                        noDataText="Нет данных для отображения"
                                        wordWrapEnabled={true}
                                        //onRowUpdating={(data) => {onSaveReads(data); updateCountNotReads(selectedDog);}}
                                        //onSaved={(data) => {onSaveReads(data);}}
                                        //onRowUpdating = {(data) => {onSaveReads(data)}}
                                        onCellPrepared = {(e) => onCellPrepared(e)}//раскраска
                                        onEditingStart={onEditingStart}
                                        allowColumnReordering={true}
                                        allowColumnResizing={true}
                                        rowAlternationEnabled={true}
                                        columnWidth={'auto'}
                                        width={'100%'}

                                    >
                                    <Toolbar>
                                        <Item location="before" locateInMenu="never">
                                            <div className='text-center'>Период: <br/><b>{currentPeriod.periodString}</b></div>
                                        </Item>
                                        <Item location="before" widget="dxButton" visible={isLarge} locateInMenu="auto">
                                            <Button disabled={selectedPoints.length===0 || currentPeriod === {}} type='default' text="Показать" icon="refresh" onClick={onRefreshClick} />
                                        </Item>
                                        <Item locateInMenu="never" location="after">
                                            <div ref={editActionsRefCallback} className="range-volumes-edit-actions is-disabled">
                                                <Button icon="save" text="Сохранить" onClick={saveTest} />
                                                <Button icon="close" text="Отмена" onClick={handleCancelClick} />
                                            </div>
                                        </Item>
                                        <Item location="after" widget="dxButton" locateInMenu="auto" >
                                            <Button className='block' text={'Массовая загрузка'} icon={'exportxlsx'} onClick={()=>setPopupVisible(true)}>
                                            </Button>
                                        </Item>
                                    </Toolbar>
                                        <Paging defaultPageSize={12} />
                                        <Scrolling columnRenderingMode="virtual" />
                                        <Sorting mode="multiple" />
                                        <FilterRow
                                            visible={true} />
                                        <HeaderFilter visible={true} />
                                        <Pager
                                            visible={true}
                                            allowedPageSizes={[5, 12, 20, 'all']}
                                            displayMode={'full'}
                                            showPageSizeSelector={true}
                                            showInfo={true}
                                            showNavigationButtons={true} />
                                        <Editing
                                            mode="batch"//batch//cell
                                            allowUpdating={true}
                                            allowAdding={false}
                                            allowDeleting={false}
                                            selectTextOnEditStart={true}
                                        />
                                        <Column visible={false} dataField="kod_dog" caption="Код договора" dataType="number" allowEditing={false}/>
                                        <Column visible={false} dataField="kod_numobj" caption="Код объекта (PK)" dataType="number" allowEditing={false}/>
                                        <Column visible={false} dataField="kod_obj" caption="Код объекта" dataType="number" allowEditing={false}/>
                                        <Column dataField="num_obj" caption="№ объекта энергоснабжения" dataType="number" allowEditing={false} width={70} fixed={true} fixedPosition="left"/>
                                        <Column dataField="name" caption="Наименование объекта энергоснабжения" dataType="string" allowEditing={false} fixed={true} fixedPosition="left"/>
                                        <Column dataField="adr" caption="Адрес объекта энергоснабжения" dataType="string" allowEditing={false}/>
                                        <Column
                                            dataField="col6_ls_d1"
                                            caption="Кол-во ЛС ФЛ по 1 диапазону без многодетных, шт."
                                            dataType="number"
                                            cellRender={editableColRender}
                                            editCellRender={editCellRender}
                                        />
                                        <Column
                                            dataField="col7_vol_d1"
                                            caption="Суммарный ОБЪЁМ по 1 диапазону без многодетных, кВт·ч"
                                            dataType="number"
                                            setCellValue={setVolCellValue('col7_vol_d1')}
                                            cellRender={editableColRender}
                                            editCellRender={editCellRender}
                                        />
                                        <Column
                                            dataField="col8_vol_odn_d1"
                                            caption="Суммарный ОБЪЁМ ОДН по 1 диапазону, кВт·ч"
                                            dataType="number"
                                            setCellValue={setVolCellValue('col8_vol_odn_d1')}
                                            cellRender={editableColRender}
                                            editCellRender={editCellRender}
                                        />
                                        <Column
                                            dataField="col9_ls_md_d1"
                                            caption="Кол-во многодетных ЛС ФЛ по 1 диапазону, шт."
                                            dataType="number"
                                            cellRender={editableColRender}
                                            editCellRender={editCellRender}
                                        />
                                        <Column
                                            dataField="col10_vol_md_d1"
                                            caption="Суммарный ОБЪЁМ по 1 диапазону по многодетным ЛС, кВт·ч"
                                            dataType="number"
                                            setCellValue={setVolCellValue('col10_vol_md_d1')}
                                            cellRender={editableColRender}
                                            editCellRender={editCellRender}
                                        />
                                        <Column
                                            dataField="col11_ls_d2"
                                            caption="Кол-во ЛС ФЛ по 2 диапазону, шт."
                                            dataType="number"
                                            cellRender={editableColRender}
                                            editCellRender={editCellRender}
                                        />
                                        <Column
                                            dataField="col12_vol_d2"
                                            caption="Суммарный ОБЪЁМ по 2 диапазону, кВт·ч"
                                            dataType="number"
                                            setCellValue={setVolCellValue('col12_vol_d2')}
                                            cellRender={editableColRender}
                                            editCellRender={editCellRender}
                                        />
                                        <Column
                                            dataField="col13_ls_d3"
                                            caption="Количество ЛС ФЛ по 3 диапазону, шт."
                                            dataType="number"
                                            cellRender={editableColRender}
                                            editCellRender={editCellRender}
                                        />
                                        <Column
                                            dataField="col14_vol_d3"
                                            caption="Суммарный ОБЪЁМ по 3 диапазону, кВт·ч"
                                            dataType="number"
                                            setCellValue={setVolCellValue('col14_vol_d3')}
                                            cellRender={editableColRender}
                                            editCellRender={editCellRender}
                                        />
                                        <Column
                                            dataField="col5_vol_total"
                                            caption="Суммарный ОБЪЁМ по всем диапазонам, кВт·ч"
                                            dataType="number"
                                            allowEditing={false}
                                            calculateCellValue={calcCol5VolTotal}
                                        />
                                        <Column dataField="t_sent" caption="Дата передачи" dataType="datetime" allowEditing={false}/>
                                        <Column
                                            dataField="accepted"
                                            caption="Принят к расчету"
                                            dataType="boolean"
                                            allowEditing={false}
                                            cellRender={acceptedCellRender}
                                        />
                                        <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                                        <Paging defaultPageSize={10} />
                                    </DataGrid>
                                    </>
                                    :
                                    <div className='text-center-horizontal-vertical d-none d-md-block'><strong>Для ввода интегральных показаний выберите точки учета и нажмите кнопку «Показать»</strong></div>

                            }
                        </div>
                    </div>
                </div>
                <>
                <PopupIntegral
                    visible={loadExcelVisible}
                    title={'Загрузить файл'}
                    onHiding={onHidingIntegralPopup}
                    multiple={uploadMultiple}
                    onSendFile={onSendIntegralFile}
                />
                <PopupInterval
                    visible={loadIntervalVisible}
                    title={'Загрузить файл'}
                    onHiding={onHidingIntervalPopup}
                    multiple={uploadMultiple}
                    onSendFile={onSendIntervalFile}
                />
                <Popup
                    visible={popupVisible}
                    dragEnabled={true}
                    hideOnOutsideClick={true}
                    showCloseButton={true}
                    showTitle={true}
                    onHiding={hidePop}
                    maxWidth={370}
                    maxHeight={'90%'}
                    height={'auto'}
                    titleRender={()=>PopupTitleWithIcon('dx-icon-exportxlsx', "Массовая загрузка",hidePop)}
                >
                    <ScrollView width='100%' height='100%'>
                        <div className="row justify-content-around">
                            <div className="col-sm-12 mt-3">
                                <b>Показания:</b>
                                <Button className={'block mt-12 mt-3'} id="load-integral-template" text="Скачать шаблон" icon="import" disabled={!selectedPoints.length || !currentPeriod.ym} onClick={loadRangeVolumesTemplate} />
                                <Button className={'block mt-12 mt-3'} id="load-integral" text="Загрузить показания" icon="export" onClick={loadExcel} />
                            </div>
                        </div>
                    </ScrollView>
                </Popup>

                <ErrorPopup
                    visible={leavePopupVisible}
                    title="Внимание"
                    text="Изменения в таблице не сохранены. Вы точно хотите уйти?"
                    icon={faTriangleExclamation}
                    width={480}
                    classNameColorIcon="main-color-light"
                    btnVisible={true}
                    btnVisibleCancel={true}
                    textOk="Да"
                    textCancel="Нет"
                    onCancel={onLeaveCancel}
                    onCancelWithOk={onLeaveCancel}
                    onOk={onLeaveContinue}
                />

                </>
            </div>
            : <AccessDenied/>}</>
    )
}

export default RangeVolumesPage
